import styled from "styled-components";

export const Title = styled.h1`
  font-size: 2.1vw;
  color: ${({ theme }) => theme.colors.primaryText};
  letter-spacing: 0.1rem;
  margin: 0;

  @media (max-width: 48rem) {
    font-size: 1.8rem;
    letter-spacing: 0.05rem;
  }
`;

export const Message = styled.p`
  color: white;
  font-size: 1.2vw;
  max-width: 35vw;
  font-weight: 600;
  margin: 0;

  @media (max-width: 48rem) {
    color: ${({ theme }) => theme.colors.primaryText};
    font-size: 1.1rem;
    max-width: 100%;
  }
`;

export const FullWidthMsg = styled.p`
  margin: 0;
  max-width: 100%;
  color: white;
  font-size: 2rem;
`;

export const DesktopMessage = styled(Message)`
  @media (max-width: 48rem) {
    display: none;
  }
`;

export const Slogan = styled.h3`
  font-size: 1.5vw;
  color: ${({ theme }) => theme.colors.primaryText};
  letter-spacing: 0.1rem;
  margin: 0;

  @media (max-width: 48rem) {
    font-size: 1.3rem;
  }
`;

export const LinkTitle = styled.p`
  color: ${({ theme }) => theme.colors.turquioze};
  margin: 0;
  font-size: 1vw;
  font-weight: 600;

  @media (max-width: 48rem) {
    font-size: 1rem;
  }
`;
